import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import Loading from "../../../../common/components/ui/loading/Loading";
import FormEditMaintenance from "../forms/FormEditMaintenance";
import {
  getDataRenterVehicle,
  updateMaintenance,
} from "../../../../common/services/maintenance.api";
import { IMaintenance } from "../../../../types/maintenance.type";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";

type Props = {
  maintenanceId: null | string;
  onClose?: () => void;
};

export default function ModalEditMaintenance(props: Props) {
  const [maintenanceId, setMaintenanceId] = useState<string | null>(null);
  const [maintenanceData, setMaintenanceData] = useState<IMaintenance | null>(
    null
  );
  const { showToast, notifyInfo } = useToastContext();
  const [formRequestErrors] = useState([]);
  const notifySuccess = (text: string) => showToast({ text, type: "success" });
  const notifyError = (text: string) => showToast({ text, type: "error" });

  useEffect(() => {
    props.maintenanceId !== maintenanceId &&
      setMaintenanceId(props.maintenanceId);
  }, [props.maintenanceId, maintenanceId]);
  useEffect(() => {
    async function loadMaintenanceData(maintenanceId: string) {
      if (!maintenanceId) return;

      const { data, ok } = await getDataRenterVehicle(maintenanceId);
      if (ok) {
        setMaintenanceData(data as unknown as IMaintenance);
      }
    }

    setMaintenanceData(null);
    if (maintenanceId) loadMaintenanceData(maintenanceId);
  }, [maintenanceId]);

  async function saveMaintenance(dataToSave: IMaintenance) {
    try {
      const currentOdometerStr = dataToSave.odometer;
      const isNumericAndPositive = /^\d+$/.test(currentOdometerStr);

      if (!isNumericAndPositive) {
        const msg =
          "O hodômetro atual é inválido. Deve conter apenas números e não pode ser negativo.";
        notifyError(msg);
        return {
          ok: false,
          data: dataToSave,
          errors: [{ message: msg, path: [] }],
        };
      }
      const currentOdometer = parseInt(currentOdometerStr, 10);

      if (
        maintenanceData &&
        typeof maintenanceData.odometerLocavibe === "string"
      ) {
        const initialOdometer = parseInt(maintenanceData.odometerLocavibe, 10);

        if (isNaN(initialOdometer)) {
          console.warn(
            "Hodômetro inicial inválido, pulando a comparação:",
            maintenanceData.odometerLocavibe
          );
        } else if (currentOdometer < initialOdometer) {
          const msg = `O hodômetro atual (${currentOdometer}) não pode ser menor que o inicial.`;
          notifyError(msg);
          return {
            ok: false,
            data: dataToSave,
            errors: [{ message: msg, path: [] }],
          };
        }
      }

      const response = (await updateMaintenance(maintenanceId as string, {
        ...dataToSave,
        budgetMaintenance: maintenanceData?.budgetMaintenance,
        observations: maintenanceData?.observations,
      })) as unknown as {
        amountFine: number;
        ok: boolean;
        data: unknown;
        errors: unknown;
        message: string;
      };

      if (response.amountFine) {
        notifyInfo(
          `Caso haja necessidade de troca de óleo. Multa de atraso de revisão de R$${response.amountFine}`
        );
      }

      const { ok, data, errors } = response;
      if (ok && data) {
        setMaintenanceData(data as IMaintenance);
        notifySuccess(
          `Manutenção do Cliente "${maintenanceData?.name}" atualizado!`
        );
        return {
          ok,
          data: data as IMaintenance,
          errors: (errors as unknown[]) || [],
        };
      }

      // Em caso de erro vindo do backend
      if (!ok) {
        notifyError(response.message as string);
      }
      return {
        ok,
        data: (data as IMaintenance) || dataToSave,
        errors: (errors as unknown[]) || [{ message: response.message || "Erro", path: [] }],
      };
    } catch (err) {
      return {
        ok: false,
        data: dataToSave,
        errors: [{ message: (err as Error).message, path: [] }],
      };
    }
  }

  return (
    <Modal
      size={"5xl"}
      className="relative text-black"
      show={true}
      onClose={() => props.onClose && props.onClose()}
    >
      <Modal.Header>
        <h3 className="dark:text-black">{`Editando Manutenção : ${(maintenanceData || {})?.licensePlate
          }`}</h3>
      </Modal.Header>
      <Modal.Body>
        {maintenanceData ? (
          <FormEditMaintenance
            data={maintenanceData}
            onSubmit={saveMaintenance}
            formRequestErrors={formRequestErrors}
          />
        ) : (
          <Loading />
        )}
      </Modal.Body>
    </Modal>
  );
}
